import { useContext } from 'react'

import { ExtraFormContext } from '../components/Form'

export default function useExtraFormContext(): any {
  const extraCtx = useContext(ExtraFormContext)
  return extraCtx || {}
}
